import React, {useEffect} from "react";
import {Row} from "react-bootstrap";
import {Constraint, DeviceCreateParameters} from "../client/EventScheduleClient";
import {BuildingInput} from "./BuildingInput";
import {Building} from "./BuildingStatus";
import {BuildingEventConstraints} from "./BuildingEventConstraint";
import {Select} from "./common/MuiSelect";
import {SelectOption} from "./OnboardingForm";
import {ControlStrategy} from "../client/BuildingClient";

interface DeviceEventProps {
    buildings: Building[]
    eventType: string
    constraint: Constraint | null
    setConstraint: (constraint: Constraint | null) => void
    disabled: boolean
    allowBuildingChange: boolean
    setParameters: (ps: DeviceCreateParameters) => void
    parameters?: DeviceCreateParameters
    controlStrategies: ControlStrategy[]
}

export const DeviceEvent = ({
                                buildings,
                                eventType,
                                constraint,
                                setConstraint,
                                disabled,
                                allowBuildingChange,
                                setParameters,
                                parameters,
                                controlStrategies,
                            }: DeviceEventProps) => {

    useEffect(() => {
        if (parameters) {
            setParameters({...parameters, eventType})
        }
    }, [eventType]);

    function handleSetBuilding(building: Building) {
        setConstraint(null)
        setParameters({buildingId: building.id, eventType})
    }

    const singleControlStrategy = controlStrategies.find(cs => cs.id === parameters?.controlStrategyId);

    return <div data-testid={'deviceEvent'}>
        <Row>
            <BuildingInput className={'mb-3'}
                           disabled={disabled || !allowBuildingChange}
                           buildings={buildings}
                           onBuildingChange={handleSetBuilding}
                           building={buildings.find(b => b.id==parameters?.buildingId)}/>
        </Row>
        {
            parameters?.buildingId && (
            <Row>
                <Select className={'mb-3'}
                        data-testid={'controlStrategySelect'}
                        label={'Control Strategy'}
                        disabled={disabled || !allowBuildingChange}
                        onChange={(changeEvent: SelectOption) => setParameters({...parameters, controlStrategyId: controlStrategies.find(cs => String(cs.id) === changeEvent.id)?.id})}
                        options={controlStrategies.map(controlStrategy => ({id: String(controlStrategy.id), label: controlStrategy.name}))}
                        initialValue={singleControlStrategy ?  {id: String(singleControlStrategy.id), label: singleControlStrategy.name} : undefined}
                />
            </Row>)
        }
        {constraint &&
            <BuildingEventConstraints constraint={constraint}/>}
    </div>
}
